import { gql } from '@apollo/client';

export const DELETE_USER_RELATIONSHIP = gql`
mutation DeleteRelationship($userId1: Int!, $userId2: Int!, $relationshipType: String!) {
  deleteRelationship(userId1: $userId1, userId2: $userId2, relationshipType: $relationshipType) {
    id
    siblings {
      id
      name
      photoUrl
    }
  }
}
`;
